import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({
  dataComponents: {
    drawer: { columns },
  },
}: ComposedTheme) => ({
  maxPrimaryLabel: {
    fontFamily: columns.maxPrimary.font.fontFamily,
    fontSize: columns.maxPrimary.font.fontSize,
    fontStyle: columns.maxPrimary.font.fontStyle,
    fontWeight: columns.maxPrimary.font.fontWeight,
    color: columns.maxPrimary.color,
    margin: '5px 0 0 16px',
  },
  noResults: {
    fontFamily: columns.text.font.fontFamily,
    color: columns.text.color,
    marginLeft: 8,
  },
  nonPrimary: {
    paddingLeft: 20,
    paddingTop: 8,
    marginTop: 8,
    borderTop: `2px solid ${columns.text.color}`,
    '&.withNoPrimary': {
      padding: 0,
      margin: 0,
      border: 'none',
    },
  },
  primary: {
    minHeight: 35,
  },
});

export default createUseStyles(styles);
